import {
  useCustomerAddressSelector,
  useCustomerRefSelector,
} from "Store/userIdentification/userIdentificationSelectors";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { PostalAddressDto } from "Store/interfaces/PostalAddressDto";
import { userIdentificationV2Start } from "Store/userIdentification/userIdentificationSlice";
import { isDefined } from "Utils/functions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const useCustomerAddress = (
  featureToggleCustomerAddress: boolean,
  productBackendName?: ProductBackendName,
): PostalAddressDto | undefined => {
  const dispatch = useDispatch();
  const customerRef = useCustomerRefSelector();
  const customerAddress = useCustomerAddressSelector();

  useEffect(() => {
    if (!productBackendName) {
      return;
    }
    const addressExists = isDefined(customerAddress);
    if (
      featureToggleCustomerAddress &&
      isDefined(customerRef) &&
      productBackendName === ProductBackendName.ADVICE &&
      !addressExists
    ) {
      dispatch(userIdentificationV2Start({ customerRef }));
    }
  }, [customerRef, productBackendName]);

  return customerAddress;
};
